import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import '../styles/NotFound.css';

function FredFirmware() {
  return (
    <div className="fred-firmware-page">
      <Navigation />
      <section className="esp32-section">
        <div className="esp32-container">
          <h1>Fred Firmware</h1>
          <p className="esp32-intro">Fred firmware update information coming soon.</p>
          <div className="esp32-form">
            <p>This page is under construction. Please check back later for Fred firmware update instructions.</p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default FredFirmware;
